import React from "react";
import { img, imgVariant, imgSrcSet } from "@/api";

/**
 * SmartImage — performance-optimized <img>.
 * - Serves optimized WebP variants via backend ?w= for internal media.
 * - Lazy-loads by default (loading="lazy", decoding="async").
 * - Provides responsive srcSet + sizes for internal media.
 *
 * Props: src, alt, className, style, sizes, widths, eager (bool), width (fallback single variant)
 */
export default function SmartImage({
  src,
  alt = "",
  className = "",
  style,
  sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 800px",
  widths = [400, 800, 1200, 1600],
  eager = false,
  width,
  ...rest
}) {
  if (!src) return null;
  const srcSet = imgSrcSet(src, widths);
  const baseSrc = width ? imgVariant(src, width) : img(src);
  return (
    <img
      src={baseSrc}
      srcSet={srcSet || undefined}
      sizes={srcSet ? sizes : undefined}
      alt={alt}
      className={className}
      style={style}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      fetchpriority={eager ? "high" : "auto"}
      {...rest}
    />
  );
}
